import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/login')({
  component: LoginPage,
});

function LoginPage() {
  const { t } = useTranslation();
  return (
    <main className="grid min-h-screen place-items-center px-4">
      <div className="w-full max-w-sm space-y-8 text-center">
        <div className="flex flex-col items-center">
          <img src="/icon.png" alt="" className="mb-4 h-20 w-20" />
          <h1 className="text-4xl font-bold tracking-tight">{t('app.name')}</h1>
          <p className="mt-2 text-sm text-zinc-400">{t('app.tagline')}</p>
        </div>
        <a
          href="/api/auth/login"
          className="inline-flex w-full items-center justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2 focus:ring-offset-zinc-950"
        >
          {t('login.button')}
        </a>
      </div>
    </main>
  );
}
